<div class="object-documents-tab">
  @if (isResolving()) {
    <div class="object-documents-tab__loading">
      <p-progressSpinner styleClass="object-documents-tab__spinner" strokeWidth="3" />
    </div>
  } @else if (hasError()) {
    <div class="object-documents-tab__error">
      <span>{{ 'DOCUMENT_MANAGEMENT.LOAD_ERROR' | translate }}</span>
    </div>
  } @else {
    <tf-folder-browser
      [rootFolderId]="rootFolderId()"
      [rootLabel]="'DOCUMENT_MANAGEMENT.OBJECT_DOCUMENTS_LABEL' | translate" />
  }
</div>
